import BaseOption from "%/dynamic-component-editor/classes/base-option";
import { inspectorTools } from "%/dynamic-component-editor/inspector/inspector-tool-map";
import { themeStructure } from "@vcl";
import { camelToTitleCase } from "@bloglovin/vue-framework";

const CSS_LENGTH_PATTERN = /^-?(\d*\.)?\d+(px|rem|em|%|vh|vw|vmin|vmax|ch|pt)$/;

function isCssLength(value) {
  return String(value).trim().split(/\s+/)
      .every(part => part === "0" || CSS_LENGTH_PATTERN.test(part));
}

export default class BorderRadius extends BaseOption {
  static userInterfaceComponent = (optionValues, themeId, state) => {
    let suffix = "px";
    const selectOptions = [];

    if (themeId !== undefined) {
      themeStructure.size.borderRadius.forEach(size => {
        const pixelValue = BaseOption._getStyleValuePropertiesFromTheme("size.borderRadius", themeId)[size];
        if (pixelValue === undefined || pixelValue === null || pixelValue === "") {
          return;
        }
        selectOptions.push({
          value: size,
          label: camelToTitleCase(size),
          secondaryLabel: pixelValue,
        });

        const relatedBorderRadiusKey = this.getBorderRadiusKey(optionValues, state);

        if (optionValues[relatedBorderRadiusKey] === size) {
          suffix = pixelValue;
        }
      });
    }

    return {
      label: "Corner Radius",
      component: inspectorTools.AUTOCOMPLETE,
      props: {
        allowCustomValue: true,
        showAllResultsOnClick: true,
        suffix: suffix,
        items: selectOptions,
      },
    };
  };

  static defaultValue = "none";

  static convertConfigValueToCompiledValue(configValue, themeId) {
    let value = BaseOption._getStyleValuePropertiesFromTheme("size.borderRadius", themeId)[configValue];
    if (!value && typeof configValue === "number") {
      value = configValue + "px";
    }
    if (!value && typeof configValue === "string" && isCssLength(configValue)) {
      value = configValue;
    }
    if (!value || value.toString() === "0") {
      return "0px";
    }

    return value;
  }

  static getBorderRadiusKey(optionValues, state) {
    return Object.keys(optionValues).find(key => {
      const parts = key.split(".");
      return (
        parts[0] === state &&
        parts[parts.length - 1] === "border-radius"
      );
    });
  }
}
